module.exports = __webpack_public_path__ + "img/diag-light.45502951.svg";